import { render, staticRenderFns } from "./orderDailyChartWidget.vue?vue&type=template&id=63555371&"
import script from "./orderDailyChartWidget.vue?vue&type=script&lang=js&"
export * from "./orderDailyChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports